import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { useMemo } from "react";
import { SessionProvider } from "../features/auth/session";
import { DesktopBridge } from "../features/desktop/DesktopBridge";
import { muiThemeFor, useActiveTheme } from "../lib/customTheme";
import { ToastProvider } from "../lib/toast";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const active = useActiveTheme();
  const theme = useMemo(() => muiThemeFor(active), [active]);
  return (
    <ThemeProvider theme={theme} defaultMode="dark">
      <CssBaseline />
      <ToastProvider>
        <SessionProvider>
          <DesktopBridge />
          <Outlet />
        </SessionProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
